<template>
	<div class="manage_page fillcontain">
		<el-row style="height: 100%;">
      <el-col :span="4" style="min-height: 100%; position: relative">
        <div class="malltop">
          <el-menu :default-active="defaultActive" style="min-height: 100%;" theme="dark" router>
            <template v-for="(item,index) in menuList">
              <el-menu-item :index="item.url" v-if="item.children.length==0" :key="index">
                {{item.name}}
              </el-menu-item>
              <el-submenu :index="index.toString()" v-if="item.children.length>0">
                <template slot="title">
                  {{item.name}}
                </template>
                <el-menu-item
                  :index="chirdenItem.url"
                  v-for="(chirdenItem,chirdeIndex) in item.children"
                  :key="chirdeIndex"
                >{{chirdenItem.name}}</el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </el-col>
			<el-col :span="20" style="height: 100%;overflow: auto;">
				<keep-alive>
				    <router-view></router-view>
				</keep-alive>
			</el-col>
		</el-row>
  	</div>
</template>

<script>
  import { getJurisdiction } from "../api/api"
  export default {
    data(){
      return {
        menuList:[]
      }
    },
    methods:{
      getJurisdiction(){
        getJurisdiction({operationId:JSON.parse(sessionStorage.getItem('user')).id}).then(res=>{
          this.menuList=res;
        }).catch(error=>{
          console.log(error);
        })

      },
    },
    created(){
      this.getJurisdiction()
    },
    computed: {
      defaultActive: function(){
        return this.$route.path.replace('/', '');
      }
    },
  }
</script>


<style lang="less" scoped>
	@import '../style/mixin';
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .sidebar {
    position: fixed;
    border-right: 1px solid rgba(0,0,0,.07);
    overflow-y: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    transition: transform .25s ease-out;
    width: 300px;
    z-index: 3;
  }
  .sidebar::-webkit-scrollbar {
    width: 4px
  }
  .sidebar::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px
  }
  .sidebar:hover::-webkit-scrollbar-thumb {
    background: hsla(0,0%,53%,.4)
  }
  .sidebar:hover::-webkit-scrollbar-track {
    background: hsla(0,0%,53%,.1)
  }
  .malltop{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-y: auto
  };
  /*@media screen and (min-width: 960px) {*/
    /*.malltop{*/
      /*height: 610px;*/
      /*overflow-y: auto;*/
    /*}*/
  /*}*/
  /*@media screen and (min-width: 1400px) {*/
    /*.malltop{*/
      /*height: 970px;*/
      /*overflow-y: auto;*/
    /*}*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/page/manage.vue